export class ModelingDetectObjectBffUrl {
  static createDetectObjects() {
    return `modeling/detect_objects`;
  }
}
